import React from 'react';
import { Reveal } from './Reveal';
import type { Principle } from '../types/content';
interface PrincipleListProps {
  items: Principle[];
  columns?: 2 | 4;
  tone?: 'light' | 'dark';
}
export function PrincipleList({
  items,
  columns = 2,
  tone = 'light'
}: PrincipleListProps) {
  const grid = columns === 4 ? 'sm:grid-cols-2 lg:grid-cols-4' : 'sm:grid-cols-2';
  const dark = tone === 'dark';
  return <ul className={`grid gap-x-10 gap-y-10 ${grid}`} data-id="element-212" data-mp="2k5j6q5gd7id2">
      {items.map((item, i) => <li key={item.title} className={`border-t pt-6 ${dark ? 'border-champagne-100/15' : 'border-midnight-900/15'}`} data-id="element-213" data-mp="2g34nvlcp4ils" data-mpi={i}>
          <Reveal delay={i * 0.04} data-id="element-214" data-mp="2b3a0hrs4qb5h">
            <h3 className={`font-serif text-2xl ${dark ? 'text-champagne-50' : 'text-midnight-900'}`} data-id="element-215" data-mp="2b6o04s9es698">{item.title}</h3>
            <p className={`mt-3 text-[15px] leading-relaxed ${dark ? 'text-champagne-100/70' : 'text-midnight-900/70'}`} data-id="element-216" data-mp="zpehu920nk9i">{item.description}</p>
          </Reveal>
        </li>)}
    </ul>;
}